import React from 'react';
import { EntitiesLayout } from './entities.layout';
import { PagePath } from '../../../navigation/navigation.enums';

export function DepartmentEntitiesPage(): JSX.Element {
  return <EntitiesLayout path={PagePath.analyticsDepartments} type="departments" />;
}
